// Chaves de query do acesso (/v1/access/me e /v1/access/catalog), num módulo à
// parte para não acoplar quem só precisa delas (ex.: hooks/use-viewer-role.ts)
// ao resto de auth-client.ts (sessão, Better Auth, cache SWR do bootstrap) —
// um mock parcial de auth-client.ts em teste não precisa saber delas.
export const ACCESS_ME_QUERY_KEY = ["access", "me"] as const;
export const ACCESS_CATALOG_QUERY_KEY = ["access", "catalog"] as const;
